// Lightweight ES -> EN helper layer for the ES/EN floating toggle.
// The whole feature lives in this file + LanguageToggle.jsx, so it can be
// deleted in one step without touching any screen code.

export const DICT = {
  // ---- Admin navigation / layout ----
  'Dashboard': 'Dashboard',
  'Pedidos': 'Orders',
  'Restaurantes': 'Restaurants',
  'Conductores': 'Drivers',
  
  'Usuarios': 'Users',
  'Pagos y comprobantes': 'Payments & receipts',
  'Reportes': 'Reports',
  'Notificaciones': 'Notifications',
  'Configuración': 'Settings',
  'Buscar pedidos, restaurantes, conductores, usuarios...': 'Search orders, restaurants, drivers, users...',
  'En vivo': 'Live',
  'Reconectando...': 'Reconnecting...',
  'Marcar leídas': 'Mark as read',
  'Marcar todas leídas': 'Mark all as read',
  'Ver todas': 'View all',
  'Ver todos': 'View all',
  'Cerrar sesión': 'Log out',
  'Administrador': 'Administrator',
  'Abrir menú': 'Open menu',
  'Panel de Administrador': 'Admin panel',
  'Plataforma completa de delivery': 'Complete delivery platform',
  'Bienvenido al panel de control de Delibery 7': 'Welcome to the Delibery 7 control panel',
  'Bienvenido al panel de Delibery 7': 'Welcome to the Delibery 7 panel',
  'Gestión global de pedidos, restaurantes, conductores y pagos.': 'Global management of orders, restaurants, drivers and payments.',
  'Ingresa tus credenciales': 'Enter your credentials',
  'Demo: cualquier credencial funciona (autenticación simulada)': 'Demo: any credentials work (mock authentication)',
  'Correo electrónico': 'Email address',
  'Contraseña': 'Password',
  'Iniciar sesión': 'Log in',
  'Inicia sesión': 'Log in',
  'Ingresando...': 'Signing in...',

  // ---- Dashboard / reports ----
  'Resumen operativo de hoy - se actualiza en tiempo real': "Today's operations summary - updates in real time",
  'Pedidos hoy': 'Orders today',
  'Ventas de hoy': 'Sales today',
  'Ventas del mes': 'Monthly sales',
  'Pedidos Totales': 'Total orders',
  'Pedidos completados': 'Completed orders',
  'Conductores con más entregas': 'Drivers with most deliveries',
  'Rendimiento de conductores': 'Driver performance',
  'Restaurantes más activos': 'Most active restaurants',
  'Restaurantes destacados': 'Featured restaurants',
  'Últimos pedidos': 'Latest orders',
  'Últimos 7 días': 'Last 7 days',
  'Estado de pedidos': 'Order status',
  'Mapa de pedidos': 'Orders map',
  'Pedidos por día': 'Orders per day',
  'Ingresos por semana': 'Revenue per week',
  'Ingresos por tipo de servicio': 'Revenue by service type',
  'Ventas por restaurante': 'Sales by restaurant',
  'Ventas y pagos': 'Sales & payments',
  'Ventas, pagos y métricas operativas de Delibery 7': 'Sales, payments and operating metrics for Delibery 7',
  'Tiempo promedio de entrega (min)': 'Average delivery time (min)',
  'Tiempo de entrega': 'Delivery time',
  'vs. mes anterior': 'vs. last month',
  '-3 min vs. mes anterior': '-3 min vs. last month',
  'Esta semana': 'This week',
  'Este mes': 'This month',
  'Este año': 'This year',
  'Hoy': 'Today',
  'Ayer': 'Yesterday',
  'Hora': 'Time',
  'Ganancias': 'Earnings',
  'Ganancias (L)': 'Earnings (L)',
  'Ganancias de hoy': "Today's earnings",
  'Total acumulado': 'Total accumulated',
  'Total a cobrar': 'Total to collect',
  'Total': 'Total',
  'Calificación': 'Rating',
  'Reseñas': 'Reviews',
  'Comida': 'Food',
  'Envío': 'Delivery',
  'Envíos': 'Deliveries',
  'Farmacia': 'Pharmacy',
  'Supermercado': 'Supermarket',
  'Mandaditos': 'Errands',

  // ---- Orders ----
  'Gestiona todos los pedidos de la plataforma en tiempo real': 'Manage every order on the platform in real time',
  'Buscar pedido...': 'Search order...',
  'Buscar cliente...': 'Search customer...',
  'Buscar restaurante...': 'Search restaurant...',
  'Buscar por nombre o cédula...': 'Search by name or ID...',
  'Buscar restaurantes, comidas...': 'Search restaurants, food...',
  'Detalle del pedido': 'Order detail',
  'Detalle del conductor': 'Driver detail',
  'Ver detalle': 'View detail',
  'Ver mapa': 'View map',
  '# Pedido': 'Order #',
  'Pedido de': 'Order from',
  'Cliente': 'Customer',
  'Clientes': 'Customers',
  'Restaurante': 'Restaurant',
  'Conductor': 'Driver',
  'Conductor:': 'Driver:',
  'Dirección:': 'Address:',
  'Cédula:': 'ID:',
  'Estado': 'Status',
  'Todos': 'All',
  'Todos los tipos': 'All types',
  'Sin pedidos': 'No orders',
  'Nuevo': 'New',
  'Nuevos pedidos': 'New orders',
  'Pedidos nuevos': 'New orders',
  'Pedidos entrantes y en proceso': 'Incoming and in-progress orders',
  'Pedidos entregados, en camino y rechazados': 'Delivered, on the way and rejected orders',
  'En curso': 'In progress',
  'En proceso': 'In progress',
  'En cocina': 'In the kitchen',
  'En preparación': 'Preparing',
  'Listo para recoger': 'Ready for pickup',
  'Listos para recoger': 'Ready for pickup',
  'Listo, esperando conductor': 'Ready, waiting for driver',
  'En camino': 'On the way',
  'Entregado': 'Delivered',
  'Completado': 'Completed',
  'Cancelado': 'Cancelled',
  'Pendiente': 'Pending',
  'Pendientes de aprobación': 'Pending approval',
  'Pendientes de verificar': 'Pending verification',
  'Aprobación': 'Approval',
  'Aprobación del administrador': 'Administrator approval',
  'Aprobados hoy': 'Approved today',
  'Monto pendiente': 'Pending amount',
  'Estado actualizado': 'Status updated',
  'Pedido aceptado - en cocina': 'Order accepted - in the kitchen',
  'Pedido listo para recoger': 'Order ready for pickup',
  'Pedido cancelado': 'Order cancelled',
  'Pedido rechazado': 'Order rejected',
  'Pedido completado': 'Order completed',
  'Pedido ya entregado': 'Order already delivered',
  'Pedido no encontrado': 'Order not found',
  'Cargando pedido...': 'Loading order...',
  'Este pedido fue cancelado': 'This order was cancelled',
  'Este pedido no está asignado a ti': 'This order is not assigned to you',
  'Ver pedido completado': 'View completed order',
  'Cancelar pedido': 'Cancel order',
  'Confirmar pedido': 'Confirm order',
  'Realizar pedido': 'Place order',
  'Nuevo pedido': 'New order',
  'Nuevo mandadito': 'New errand',
  'Aceptar': 'Accept',
  'Rechazar': 'Reject',
  'Eliminar / Archivar': 'Delete / Archive',
  'Solicitudes abiertas de compras, recogidas y envíos': 'Open requests for shopping, pickups and deliveries',
  'Tipo de mandado': 'Errand type',
  'Tipo de servicio': 'Service type',
  'Tipos de servicios': 'Service types',
  'Farmacia y supermercado': 'Pharmacy and supermarket',
  'Farmacia, supermercado, envíos y más': 'Pharmacy, supermarket, deliveries and more',
  'Farmacia, supermercado, paquetes y más': 'Pharmacy, supermarket, packages and more',

  // ---- Restaurants admin ----
  'Crea, edita, activa o desactiva restaurantes y sus menús': 'Create, edit, enable or disable restaurants and their menus',
  'Nuevo restaurante': 'New restaurant',
  'Editar restaurante': 'Edit restaurant',
  'Publicar restaurante': 'Publish restaurant',
  'Restaurante actualizado': 'Restaurant updated',
  'Restaurante activado': 'Restaurant enabled',
  'Restaurante desactivado': 'Restaurant disabled',
  'Restaurante eliminado': 'Restaurant deleted',
  'Restaurante publicado y activado': 'Restaurant published and enabled',
  'Restaurante no disponible': 'Restaurant unavailable',
  'Restaurante abierto': 'Restaurant open',
  'Restaurante cerrado temporalmente': 'Restaurant temporarily closed',
  'Nombre del negocio': 'Business name',
  'Correo del negocio': 'Business email',
  'Nombre': 'Name',
  'Nombre completo': 'Full name',
  'Descripción': 'Description',
  'Categoría': 'Category',
  'Categorías': 'Categories',
  'Nueva categoría': 'New category',
  'Menú': 'Menu',
  'Menú y precios': 'Menu & prices',
  'Nuevo producto': 'New product',
  'Agregar producto': 'Add product',
  'Editar producto': 'Edit product',
  'Guardar producto': 'Save product',
  'Sin productos en esta categoría': 'No products in this category',
  'Sin productos. Agrega el primero.': 'No products yet. Add the first one.',
  'Logo y banner': 'Logo and banner',
  'Horario de atención': 'Opening hours',
  'Horario de operación': 'Operating hours',
  'Pedido mínimo (L)': 'Minimum order (L)',
  'Costo de envío': 'Delivery fee',
  'Costo de envío (L)': 'Delivery fee (L)',
  'Costo base de envío (L)': 'Base delivery fee (L)',
  'Costo por km adicional (L)': 'Cost per extra km (L)',
  'Comisión a restaurantes (%)': 'Restaurant commission (%)',
  'Tarifas y comisiones': 'Fees & commissions',
  'Información de la empresa': 'Company information',
  'Información visible para los clientes': 'Information visible to customers',
  'Información': 'Information',
  'Mensaje de agradecimiento': 'Thank-you message',
  'Notificaciones y operación': 'Notifications & operations',
  'Alertas de nuevos pedidos': 'New order alerts',
  'Alertas de comprobantes': 'Receipt alerts',
  'Alertas de conductores': 'Driver alerts',
  'Alertas de pedidos, pagos, conductores y restaurantes': 'Alerts for orders, payments, drivers and restaurants',
  'Notificar al administrador en tiempo real': 'Notify the administrator in real time',
  'Asignación automática de conductores': 'Automatic driver assignment',
  'Asignar al conductor disponible más cercano': 'Assign the closest available driver',
  'Configuración guardada': 'Settings saved',
  'Configuración de cuenta': 'Account settings',
  'Datos de demostración': 'Demo data',
  'No incluido en el alcance actual': 'Not included in the current scope',
  'Próximamente': 'Coming soon',
  'Próximamente - requiere pasarela de pago': 'Coming soon - requires a payment gateway',

  // ---- Drivers admin ----
  'Aprueba, activa o desactiva conductores de la plataforma': 'Approve, enable or disable platform drivers',
  'Nuevo conductor': 'New driver',
  'Crear conductor': 'Create driver',
  'Conductor actualizado': 'Driver updated',
  'Conductor aprobado': 'Driver approved',
  'Conductor rechazado': 'Driver rejected',
  'Conductor desactivado': 'Driver disabled',
  'Conductor reactivado': 'Driver re-enabled',
  'Conductor eliminado': 'Driver deleted',
  'Conductor removido': 'Driver removed',
  'Conductor verificado': 'Verified driver',
  'Conductor activo': 'Active driver',
  'Conductor asignado': 'Driver assigned',
  'Asignando conductor': 'Assigning driver',
  'Buscando conductor': 'Looking for a driver',
  'Buscando un conductor disponible...': 'Looking for an available driver...',
  'Esperando conductor...': 'Waiting for a driver...',
  'Cédula': 'ID number',
  'Número de cédula': 'ID number',
  'Vehículo': 'Vehicle',
  'Móvil': 'Mobile',
  'Activo': 'Active',
  'Inactivo': 'Inactive',
  'No disponible': 'Unavailable',
  'No encontrado': 'Not found',
  'Documento de identidad (foto)': 'ID document (photo)',
  'Verificación de documentos': 'Document verification',

  // ---- Users / payments admin ----
  'Clientes registrados y personal administrativo': 'Registered customers and administrative staff',
  'Nuevo usuario administrativo': 'New admin user',
  'Usuario creado': 'User created',
  'Usuario activado': 'User enabled',
  'Usuario desactivado': 'User disabled',
  'Usuario removido': 'User removed',
  'Valida transferencias bancarias y administra las cuentas de la empresa': 'Validate bank transfers and manage company accounts',
  'Bancos y cuentas': 'Banks & accounts',
  'Bancos hondureños con comprobante': 'Honduran banks with receipt',
  'Agregar banco': 'Add bank',
  'Nuevo banco': 'New bank',
  'Editar banco': 'Edit bank',
  'Editar cuenta': 'Edit account',
  'Nombre del banco': 'Bank name',
  'Número de cuenta': 'Account number',
  'Tipo de cuenta': 'Account type',
  'Selecciona un banco': 'Select a bank',
  'Métodos de pago': 'Payment methods',
  'Método de pago': 'Payment method',
  'Pagos': 'Payments',
  'Pago en verificación': 'Payment under review',
  'en verificación': 'under review',
  'Verificando tu pago': 'Verifying your payment',
  'Captura de transferencia': 'Transfer screenshot',
  'Subir captura de transferencia': 'Upload transfer screenshot',
  'Sube tu comprobante de transferencia': 'Upload your transfer receipt',
  'Realiza tu pago y sube tu comprobante': 'Make your payment and upload your receipt',
  'Nuevos comprobantes de pago pendientes': 'New payment receipts pending',
  'Efectivo contra entrega': 'Cash on delivery',
  'Tarjeta de crédito / débito': 'Credit / debit card',
  'Carga de archivos disponible próximamente - usa la URL': 'File upload coming soon - use the URL',
  'Carga de foto disponible próximamente': 'Photo upload coming soon',
  'Carga de foto disponible con el backend': 'Photo upload available with the backend',
  'Subir foto de perfil': 'Upload profile photo',

  // ---- Notifications ----
  'No tienes notificaciones': 'You have no notifications',
  'Sin notificaciones nuevas': 'No new notifications',
  'Notificaciones eliminadas': 'Notifications cleared',
  'Todas marcadas como leídas': 'All marked as read',
  'Nuevos registros pendientes de aprobación': 'New registrations pending approval',

  // ---- Generic actions ----
  'Guardar': 'Save',
  'Guardar cambios': 'Save changes',
  'Cancelar': 'Cancel',
  'Cerrar': 'Close',
  'Editar': 'Edit',
  'Eliminar': 'Delete',
  'Agregar': 'Add',
  'Ver': 'View',
  'Buscar': 'Search',
  'Resumen': 'Summary',
  'Detalles': 'Details',
  'Ocurrió un error': 'Something went wrong',
  'Completa los campos': 'Fill in the fields',
  'Completa todos los campos': 'Fill in all the fields',
  'Completa los campos obligatorios': 'Fill in the required fields',
  'Completa nombre y cuenta': 'Fill in name and account',
  'Completa nombre, teléfono y cédula': 'Fill in name, phone and ID',
  'Completa la dirección': 'Complete the address',
  'Completa tus datos': 'Complete your details',
  'El nombre es obligatorio': 'The name is required',
  'Nombre y precio son obligatorios': 'Name and price are required',
  'Teléfono': 'Phone',
  'Número de teléfono': 'Phone number',
  'Correo': 'Email',
  'Correo (opcional)': 'Email (optional)',
  'Dirección / Ubicación': 'Address / Location',
  'Dirección de entrega': 'Delivery address',
  'Mínimo 6 caracteres': 'At least 6 characters',

  // ---- Customer app ----
  'Tu ciudad, en tus manos': 'Your city, in your hands',
  'Tu ciudad,': 'Your city,',
  'en tus manos': 'in your hands',
  'Tu ciudad, más oportunidades': 'Your city, more opportunities',
  'Tu ciudad, nuestra prioridad': 'Your city, our priority',
  'Siempre más cerca de ti': 'Always closer to you',
  'Hecho para Tocoa': 'Made for Tocoa',
  'Comida  •  Mandaditos 7  •  Envíos  •  Todo en Tocoa': 'Food  •  Mandaditos 7  •  Deliveries  •  All in Tocoa',
  'Comida • Mandaditos 7 • Envíos • Todo en Tocoa': 'Food • Mandaditos 7 • Deliveries • All in Tocoa',
  'Comida, Mandaditos 7,': 'Food, Mandaditos 7,',
  'Envíos y mucho más.': 'Deliveries and much more.',
  'Comida, Mandaditos 7, envíos y seguimiento en tiempo real.': 'Food, Mandaditos 7, deliveries and real-time tracking.',
  'Todo en Tocoa': 'All in Tocoa',
  'Comenzar': 'Get started',
  'App de Clientes': 'Customer App',
  'Portal de Restaurantes': 'Restaurant Portal',
  'Ingresa tu teléfono y contraseña': 'Enter your phone and password',
  'Ingresa tus datos para continuar': 'Enter your details to continue',
  '¿Olvidaste tu contraseña?': 'Forgot your password?',
  'o continúa con': 'or continue with',
  '¿No tienes cuenta?': "Don't have an account?",
  '¿Ya tienes cuenta?': 'Already have an account?',
  'Regístrate': 'Sign up',
  'Registrarme': 'Sign up',
  'Crear cuenta': 'Create account',
  'Regístrate para comenzar a pedir': 'Sign up to start ordering',
  'Al registrarte aceptas los': 'By signing up you accept the',
  'términos y condiciones': 'terms and conditions',
  'de Delibery 7.': 'of Delibery 7.',
  'Acepto los': 'I accept the',
  'Debes aceptar los términos': 'You must accept the terms',
  'Recuperar cuenta': 'Recover account',
  'Te enviaremos un código por SMS': "We'll send you a code by SMS",
  'Enviar código': 'Send code',
  'Código enviado (demo)': 'Code sent (demo)',
  'Login con Google disponible con backend': 'Google login available with the backend',
  'Login con Apple disponible con backend': 'Apple login available with the backend',
  'Cuenta creada. ¡Bienvenido a Delibery 7!': 'Account created. Welcome to Delibery 7!',
  '¿Qué necesitas hoy?': 'What do you need today?',
  '¿Qué necesitas?': 'What do you need?',
  'Tu dirección': 'Your address',
  'Nueva dirección': 'New address',
  'Agregar nueva dirección': 'Add new address',
  'Editar dirección': 'Edit address',
  'Guardar dirección': 'Save address',
  'Dirección guardada': 'Address saved',
  'Buscar dirección o ingresar manualmente': 'Search address or enter manually',
  'Nombre del lugar o dirección': 'Place name or address',
  'Mis pedidos': 'My orders',
  'Ver mis pedidos': 'View my orders',
  'Historial de pedidos': 'Order history',
  'No tienes pedidos en curso': 'You have no orders in progress',
  'Tu carrito': 'Your cart',
  'Ver carrito': 'View cart',
  'Tu carrito está vacío': 'Your cart is empty',
  'Explora los restaurantes y agrega tus productos favoritos.': 'Browse restaurants and add your favourite products.',
  'Agregar al carrito': 'Add to cart',
  'Agregar notas': 'Add notes',
  'Se reemplazó el carrito con productos de este restaurante': 'Your cart was replaced with products from this restaurant',
  'Los productos ya no están disponibles': 'These products are no longer available',
  'Tus restaurantes favoritos': 'Your favourite restaurants',
  'Tus restaurantes guardados': 'Your saved restaurants',
  'Aún no tienes favoritos': "You don't have favourites yet",
  'Aún no has solicitado mandaditos': "You haven't requested any errands yet",
  'Aún no tienes entregas completadas': "You don't have completed deliveries yet",
  'No hay restaurantes con ese filtro.': 'No restaurants match that filter.',
  'No hay pedidos disponibles por ahora': 'No orders available right now',
  'Seguimiento de pedido': 'Order tracking',
  'Tu pedido está en camino': 'Your order is on the way',
  'Preparando tu pedido': 'Preparing your order',
  'Esperando confirmación del restaurante': 'Waiting for restaurant confirmation',
  'Te avisaremos cuando un conductor tome tu pedido': "We'll let you know when a driver takes your order",
  'Llegará en aprox.': 'Arriving in approx.',
  'Llegarás en': "You'll arrive in",
  'Entregar en': 'Deliver to',
  'Recoger en': 'Pick up at',
  'Recogiendo pedido': 'Picking up order',
  'Contactar cliente': 'Contact customer',
  'Llamando al conductor...': 'Calling the driver...',
  'Chat disponible próximamente': 'Chat coming soon',
  '¡Tu pedido ha llegado!': 'Your order has arrived!',
  '¡Tu pedido ha sido': 'Your order has been',
  'entregado!': 'delivered!',
  '¿Cómo fue tu experiencia?': 'How was your experience?',
  'Cuéntanos tu opinión (opcional)': 'Tell us your feedback (optional)',
  '¡Gracias por tu calificación!': 'Thanks for your rating!',
  '¡Gracias por confiar en Delibery 7! Tu ciudad, en tus manos.': 'Thanks for trusting Delibery 7! Your city, in your hands.',
  'Gracias por confiar en': 'Thanks for trusting',
  'Ayuda y soporte': 'Help & support',
  'Contacta soporte si tienes dudas': 'Contact support if you have questions',
  'Mandadito solicitado. Buscando conductor...': 'Errand requested. Looking for a driver...',
  'Pedido realizado. Comprobante en verificación.': 'Order placed. Receipt under review.',
  'Ej. Comprar acetaminofén y alcohol gel en Farmacia Simán': 'e.g. Buy paracetamol and hand gel at Farmacia Simán',
  'Ej. Pollo Norteño': 'e.g. Pollo Norteño',
  'Ej. Pollo, Pizza, Cafetería': 'e.g. Chicken, Pizza, Coffee shop',
  'Tu mandado, en buenas manos': 'Your errand, in good hands',
  'Rápido y seguro': 'Fast and safe',
  'Excelente sabor y llegó muy rápido. ¡Recomendado!': 'Great flavour and it arrived very fast. Recommended!',
  'Muy bueno, el combo familiar alcanza para todos.': 'Very good, the family combo is enough for everyone.',
  'Siempre pido aquí, nunca falla.': 'I always order here, it never fails.',
  'Barrio El Centro, Tocoa': 'Barrio El Centro, Tocoa',
  'Barrio, Tocoa, Colón': 'Barrio, Tocoa, Colón',
  'Tocoa, Colón': 'Tocoa, Colón',
  'Tocoa, Colón, Honduras': 'Tocoa, Colón, Honduras',

  // ---- Driver app ----
  'Accede a tu cuenta de conductor': 'Access your driver account',
  '¿Nuevo conductor?': 'New driver?',
  'Únete como conductor': 'Join as a driver',
  'Conduce tu futuro': 'Drive your future',
  'Sé parte del movimiento': 'Be part of the movement',
  'Recibe pedidos, navega y entrega. Conecta, Recoge, Entrega, Gana.': 'Get orders, navigate and deliver. Connect, Pick up, Deliver, Earn.',
  'Tu información será verificada': 'Your information will be verified',
  'Cuenta en revisión': 'Account under review',
  '¡Tu cuenta fue aprobada!': 'Your account has been approved!',
  '¡Aprobado! Comenzar': 'Approved! Get started',
  'Simular aprobación': 'Simulate approval',
  'por el administrador.': 'by the administrator.',
  'Actívate como disponible para recibir pedidos': 'Go available to start receiving orders',
  'Ahora estás disponible': 'You are now available',
  'Estás desconectado': 'You are offline',
  'Iniciar ruta': 'Start route',
  'Marcar como entregado': 'Mark as delivered',
  'Marcar listo para recoger': 'Mark ready for pickup',
  '¡Listo para entregar!': 'Ready to deliver!',
  '¡Entrega completada! +': 'Delivery completed! +',
  'Tu ganancia': 'Your earnings',
  'por pedido completado': 'per completed order',
  'Inicia sesión para continuar': 'Log in to continue',
  'Demo: 9911-1111 (aprobado) • 9911-4444 (pendiente)': 'Demo: 9911-1111 (approved) • 9911-4444 (pending)',

  // ---- Restaurant portal ----
  'Administra tu menú, precios y pedidos entrantes.': 'Manage your menu, prices and incoming orders.',
  'Administra tu menú, precios, disponibilidad y recibe pedidos en tiempo real.': 'Manage your menu, prices, availability and receive orders in real time.',
  'Administra categorías, productos, precios y disponibilidad': 'Manage categories, products, prices and availability',
  'Inicia sesión con la cuenta de tu negocio': 'Log in with your business account',
  'Demo: usa cualquier correo de un restaurante registrado (ej. pizzatocoa@gmail.com)': 'Demo: use the email of any registered restaurant (e.g. pizzatocoa@gmail.com)',
  'Perfil del negocio': 'Business profile',
  'Historial': 'History',
  'Volver': 'Back',
  'Abierto': 'Open',
  'Cerrado': 'Closed',
  'Cargando...': 'Loading...',
  'Bienvenido': 'Welcome',
  'Transferencia bancaria': 'Bank transfer',
  'Etiqueta (Casa, Trabajo...)': 'Label (Home, Work...)',
  'Barrio, calle, referencia': 'Neighbourhood, street, landmark',
  'Casa': 'Home',
  'Trabajo': 'Work',
  'Perfil': 'Profile',
  'Inicio': 'Home',
  'Favoritos': 'Favourites',
  'Carrito': 'Cart',
  'Subtotal': 'Subtotal',
  'Impuesto': 'Tax',
  'Propina': 'Tip',
  'Notas': 'Notes',
  'Notas para el restaurante': 'Notes for the restaurant',
  'Disponibilidad': 'Availability',
  'Precio': 'Price',
  'Precio (L)': 'Price (L)',
  'Cantidad': 'Quantity',
  'Acciones': 'Actions',
  'Fecha': 'Date',
  'Tipo': 'Type',
  'Monto': 'Amount',
  'Referencia': 'Reference',
  'Banco': 'Bank',
  'Comprobante': 'Receipt',
  'Aprobar': 'Approve',
  'Aprobado': 'Approved',
  'Rechazado': 'Rejected',
  'Verificado': 'Verified',
  'Entregas': 'Deliveries',
  'Entregas de hoy': "Today's deliveries",
  'Historial de entregas': 'Delivery history',
  'Disponible': 'Available',
  'Desconectado': 'Offline',
  'En línea': 'Online',
  'Ruta': 'Route',
  'Navegar': 'Navigate',
  'Llamar': 'Call',

  // ---- Remaining labels / demo copy ----
  'Ingresos': 'Revenue',
  'Ingresos (L)': 'Revenue (L)',
  'Nuevos registros': 'New registrations',
  'Pendiente de aprobación': 'Pending approval',
  'Comprobante pendiente': 'Receipt pending',
  'Restaurante / Origen': 'Restaurant / Origin',
  'Ajustes generales del sistema': 'General system settings',
  'Restablecer datos': 'Reset data',
  'Restablece todos los datos de la demo (pedidos, restaurantes, conductores, carrito) a su estado inicial.': 'Resets all demo data (orders, restaurants, drivers, cart) to its initial state.',
  'Datos del negocio': 'Business details',
  'URL del banner': 'Banner URL',
  'URL del logo': 'Logo URL',
  'Todos (': 'All (',
  'Abrir': 'Open',
  'Entregas completadas': 'Completed deliveries',
  'Comida de tus restaurantes favoritos, Mandaditos 7, envíos y mucho más. Selecciona una plataforma para explorar la demo.': 'Food from your favourite restaurants, Mandaditos 7, deliveries and much more. Pick a platform to explore the demo.',
  // categories
  'Pollo': 'Chicken',
  'Hamburguesas': 'Burgers',
  'Mexicana': 'Mexican',
  'Japonesa': 'Japanese',
  'Cafetería': 'Coffee shop',
  'Combos': 'Combos',
  'Bebidas': 'Drinks',
  'Entradas': 'Starters',
  'Extras': 'Extras',
  'Medicamentos': 'Medicines',
  'Cuidado personal': 'Personal care',
  'Despensa': 'Groceries',
  'Rollos': 'Rolls',
  'Repostería': 'Bakery',
  'Café': 'Coffee',
  'Otro': 'Other',
  'Ciudad': 'City',
  'Explorar': 'Explore',
  'Foto (URL)': 'Photo (URL)',
  'Horario': 'Hours',
  'Notas:': 'Notes:',
  'Pago:': 'Payment:',
  'Rol': 'Role',
  'Solicitar ahora': 'Request Now',
  'Somos Mandaditos 7': 'We are Mandaditos 7',
  'Escribe tu mandado y envíalo': 'Write your order and send it',
  'Cuenta bancaria': 'Bank account',
  'Agregar cuenta para tus pagos': 'Add an account for your payouts',
  'Agregar número de cédula': 'Add your ID number',
  'Datos actualizados': 'Details updated',
  'Guardando...': 'Saving...',
  'Notificaciones push': 'Push notifications',
  'Pedidos asignados y cambios de estado': 'Assigned orders and status changes',
  'Sonido de nuevos pedidos': 'New order sound',
  'Alerta sonora al entrar un pedido': 'Sound alert when an order arrives',
  'Resumen de ganancias': 'Earnings summary',
  'Recibe el total de tus entregas del día': "Get your daily delivery total",
  'Tus ganancias se depositan en esta cuenta.': 'Your earnings are deposited into this account.',
  'Titular de la cuenta': 'Account holder',
  'Banco (ej. Banco Atlántida)': 'Bank (e.g. Banco Atlántida)',
  'Placa (ej. HAB 1234)': 'Plate (e.g. HAB 1234)',
  'Moto': 'Motorcycle',
  'Bicicleta': 'Bicycle',
  'Carro': 'Car',
  'Tricimoto': 'Tuk-tuk',
  'Entrega en curso': 'Delivery in progress',
  'Pedido asignado a ti': 'Order assigned to you',
  'Nuevo pedido disponible': 'New order available',
  'Activadas': 'On',
  'Desactivadas': 'Off',
  'Ingresa tu número de cédula': 'Enter your ID number',
  'Completa banco y número de cuenta': 'Fill in the bank and account number',
  'Pago en efectivo': 'Cash payment',
  'Paga al conductor al recibir': 'Pay the driver on delivery',
  'Pagas al conductor cuando recibas tu pedido': 'You pay the driver when your order arrives',
  'Transfiere y sube tu comprobante': 'Transfer and upload your receipt',
  'Datos para tu transferencia': 'Details for your transfer',
  'Copiar todos los datos': 'Copy all details',
  'Copiado': 'Copied',
  'Datos copiados': 'Details copied',
  'N° de cuenta': 'Account number',
  'Monto a pagar': 'Amount to pay',
  'Beneficiario': 'Beneficiary',
  'Beneficiario (si es distinto)': 'Beneficiary (if different)',
  'RTN': 'Tax ID (RTN)',
  'RTN / Identidad': 'Tax ID / National ID',
  'Instrucciones para el cliente': 'Instructions for the customer',
  'Siglas': 'Initials',
  'Color de la marca': 'Brand colour',
  'Métodos de pago del cliente': 'Customer payment methods',
  'Lo que ve el cliente al pagar su pedido': 'What the customer sees when paying',
  'El conductor cobra al entregar': 'The driver collects on delivery',
  'Tarjeta': 'Card',
  'Cambiar método de pago': 'Change payment method',
  'Cobrar en efectivo': 'Collect cash',
  'Pagado por transferencia': 'Paid by bank transfer',
  'Pedido realizado. Paga en efectivo al recibir.': 'Order placed. Pay cash on delivery.',
  'Efectivo': 'Cash',
  'Marcar leídas': 'Mark read',
  'Mapa': 'Map',
  'Desde': 'Since',
  'Bebidas': 'Drinks',
  'Agregar bebidas': 'Add drinks',
  'Elige las bebidas que vendes y se agregan a tu menú al instante.': 'Pick the drinks you sell and they are added to your menu instantly.',
  'Gaseosas': 'Sodas',
  'Jugos naturales': 'Natural juices',
  'Sabores que vendes': 'Flavours you sell',
  'Precio base (L)': 'Base price (L)',
  'Tamaños (opcional)': 'Sizes (optional)',
  'Sabores (opcional)': 'Flavours (optional)',
  'Elige opciones': 'Choose options',
  'Sabor': 'Flavour',
  'Tamaño': 'Size',
  'Gaseosa': 'Soda',
  'Jugo natural': 'Natural juice',
  'Agua purificada 600 ml': 'Bottled water 600 ml',
  'Elige tu sabor favorito, bien fría': 'Pick your favourite flavour, ice cold',
  'Recién hecho, sin azúcar añadida': 'Freshly made, no added sugar',
  'Selecciona al menos una bebida': 'Select at least one drink',
  'Ingresa un precio': 'Enter a price',
  'Esas bebidas ya están en el menú': 'Those drinks are already on the menu',
  'Elige un sabor': 'Choose a flavour',
  'Para gaseosas y jugos: el cliente elige el sabor.': 'For sodas and juices: the customer picks the flavour.',
  'Ideal para gaseosas y jugos: el cliente elige el sabor.': 'Great for sodas and juices: the customer picks the flavour.',
  'Cada tamaño puede sumar un cargo extra.': 'Each size can add an extra charge.',
  'Solicitud': 'Request',
  'Soporte': 'Support',
  'Tarifa': 'Fee',
  'Tarifa del servicio': 'Service fee',
  'Titular': 'Account holder',
  'Volver a pedir': 'Order again',
  'Crear': 'Create',
  'Registrarse': 'Sign up',
  'Asignar': 'Assign',
  'Bancos activos': 'Active banks',
  'Banner / Logo (URL de imagen)': 'Banner / Logo (image URL)',
  'Detalle': 'Detail',
  'Ej. Sin cebolla, extra salsa...': 'e.g. No onion, extra sauce...',
  'Mandadito': 'Errand',
  'Mis mandaditos': 'My errands',
  'Personal administrativo': 'Administrative staff',
  'Propietario / Contacto': 'Owner / Contact',
  'Seguimiento': 'Tracking',
  'Selecciona': 'Select',
  'Ticket promedio': 'Average ticket',
  'Tiempo estimado': 'Estimated time',
  'Tiempo prom. entrega': 'Avg. delivery time',
  'Vista previa': 'Preview',
  'Conecta, Recoge, Entrega, Gana': 'Connect, Pick up, Deliver, Earn',
  'Limpiar': 'Clear',
  'Registro enviado': 'Registration submitted',
  'Cuenta aprobada': 'Account approved',
  'Aprobado': 'Approved',
  'Ahora': 'Now',
  'Hace un momento': 'A moment ago',
  'Activar sonido': 'Enable sound',
  'Silenciar sonido': 'Mute sound',
  'Simulado': 'Simulated',
  'Tu ubicación en vivo (GPS)': 'Your live location (GPS)',
  'Ubicación simulada - activa el GPS': 'Simulated location - enable GPS',
  'Llegarás en': "You'll arrive in",
  'Tomar foto': 'Take photo',
  'Subir imagen': 'Upload image',
  'Foto subida': 'Photo uploaded',
  'Foto actualizada': 'Photo updated',
  'No se pudo subir la foto': 'The photo could not be uploaded',
  'Banner del restaurante': 'Restaurant banner',
  'Banner': 'Banner',
  'Logo': 'Logo',
  'Foto del producto': 'Product photo',
  'Foto de perfil': 'Profile photo',
  'Foto de la cédula': 'ID photo',
  'Foto de tu cédula': 'Photo of your ID',
  'Documento de identidad del conductor': "Driver's ID document",
  'Sin foto de cédula': 'No ID photo',
  'Adjuntar / reemplazar cédula': 'Attach / replace ID',
  'Documento actualizado': 'Document updated',
  'El administrador verificará tu documento': 'The administrator will verify your document',
  'Toma una selfie o sube una foto': 'Take a selfie or upload a photo',
  'Captura de la transferencia': 'Transfer screenshot',
  'Sube la captura de tu transferencia bancaria': 'Upload the screenshot of your bank transfer',
  'JPG, PNG o WebP hasta 10 MB': 'JPG, PNG or WebP up to 10 MB',
  'Se muestra en la portada del restaurante': 'Shown on the restaurant cover',
  'La imagen supera los 10 MB': 'The image is larger than 10 MB',
  'Formato no válido. Usa JPG, PNG, WebP o HEIC': 'Invalid format. Use JPG, PNG, WebP or HEIC',
  'Oferta del día': 'Deal of the day',
  'Oferta especial': 'Special offer',
  'Pedir ahora': 'Order now',
  'Pedir de nuevo': 'Order again',
  'Mejor calificados': 'Top rated',
  'Envío gratis y cerca de ti': 'Free delivery near you',
  'Platillos populares': 'Popular dishes',
  'Envío GRATIS': 'FREE delivery',
  'Envío gratis': 'Free delivery',
  'GRATIS': 'FREE',
  'Promo 2x1': '2-for-1 deal',
  'Combo': 'Combo',
  '30% OFF en combos familiares': '30% OFF family combos',
  'Código TOCOA30 • solo hoy': 'Code TOCOA30 • today only',
  'Envío GRATIS en hamburguesas': 'FREE delivery on burgers',
  'En pedidos mayores a L 200': 'On orders over L 200',
  'Mandaditos 7 en minutos': 'Mandaditos 7 in minutes',
  'Farmacia, súper, paquetes y más': 'Pharmacy, groceries, parcels and more',
  '2x1 en bebidas y postres': '2-for-1 on drinks and desserts',
  'Restaurantes seleccionados': 'Selected restaurants',
  'Pizza familiar + refresco': 'Family pizza + soda',
  'Desde L 249 con envío incluido': 'From L 249 with delivery included',
  'Gracias por confiar en Delibery 7': 'Thanks for trusting Delibery 7',
  'Ver': 'View',
  'Ahorra': 'Save',
  'Termina en': 'Ends in',
};

// Weekday / month abbreviations used in charts
Object.assign(DICT, {
  'Lun': 'Mon', 'Mar': 'Tue', 'Mié': 'Wed', 'Jue': 'Thu', 'Vie': 'Fri', 'Sáb': 'Sat', 'Dom': 'Sun',
  'Ene': 'Jan', 'Abr': 'Apr', 'Ago': 'Aug', 'Dic': 'Dec',
});

// Phrase-level replacements for dynamic strings (notifications, greetings...).
const PHRASES = [
  ['¡Bienvenido de nuevo,', 'Welcome back,'],
  ['Bienvenido de nuevo,', 'Welcome back,'],
  ['En curso', 'In progress'],
  ['Disponibles', 'Available'],
  ['disponibles', 'available'],
  ['tu registro fue recibido. El administrador verificará tu cédula y datos. Esta pantalla se actualiza automáticamente cuando seas aprobado.', 'your registration was received. The administrator will verify your ID and details. This screen updates automatically once you are approved.'],
  ['realizó un pedido en', 'placed an order at'],
  ['subió un comprobante de', 'uploaded a receipt of'],
  ['entregó el pedido de', 'delivered the order of'],
  ['fue creado por el administrador', 'was created by the administrator'],
  ['se registró en la plataforma', 'registered on the platform'],
  ['se registró en la app', 'signed up on the app'],
  ['solicita aprobación', 'requests approval'],
  ['Pendiente de aprobación', 'Pending approval'],
  ['tasa de éxito', 'success rate'],
  ['vs. mes anterior', 'vs. last month'],
  ['resultados para', 'results for'],
  ['Nuevo pedido', 'New order'],
  ['cerca de ti', 'near you'],
  ['Termina en', 'Ends in'],
  ['Ahorra', 'Save'],
  ['de ti', 'from you'],
  ['pedidos nuevos', 'new orders'],
  ['Nuevo mandadito', 'New errand'],
  ['Nuevo usuario', 'New user'],
  ['Hola,', 'Hi,'],
  ['Hola ', 'Hi '],
];

// Fallback word-level map for composed / dynamic strings.
const WORDS = [
  
  ['mandaditos', 'errands'],
  ['mandadito', 'errand'],
  ['pedidos', 'orders'],
  ['pedido', 'order'],
  ['productos', 'items'],
  ['producto', 'item'],
  ['restaurantes', 'restaurants'],
  ['restaurante', 'restaurant'],
  ['conductores', 'drivers'],
  ['conductor', 'driver'],
  ['clientes', 'customers'],
  ['cliente', 'customer'],
  ['usuarios', 'users'],
  ['usuario', 'user'],
  ['entregas', 'deliveries'],
  ['entregados', 'delivered'],
  ['entregado', 'delivered'],
  ['completados', 'completed'],
  ['completado', 'completed'],
  ['cancelados', 'cancelled'],
  ['cancelado', 'cancelled'],
  ['pendientes', 'pending'],
  ['pendiente', 'pending'],
  ['activos', 'active'],
  ['activo', 'active'],
  ['disponibles', 'available'],
  ['disponible', 'available'],
  ['hoy', 'today'],
  ['ayer', 'yesterday'],
  ['semanas', 'weeks'],
  ['semana', 'week'],
  ['meses', 'months'],
  ['días', 'days'],
  ['día', 'day'],
  ['horas', 'hours'],
  ['hora', 'hour'],
  ['minutos', 'minutes'],
  ['ventas', 'sales'],
  ['ganancias', 'earnings'],
  ['comida', 'food'],
  ['envío', 'delivery'],
  ['envíos', 'deliveries'],
  ['total', 'total'],
  ['calificación', 'rating'],
  ['reseñas', 'reviews'],
];

const matchCase = (src, out) => (src[0] === src[0].toUpperCase() ? out.charAt(0).toUpperCase() + out.slice(1) : out);

const wordTranslate = (s) => {
  let out = s;
  let hit = false;
  for (const [es, en] of PHRASES) {
    if (out.includes(es)) { hit = true; out = out.split(es).join(en); }
  }
  for (const [es, en] of WORDS) {
    const re = new RegExp(`\\b${es}\\b`, 'gi');
    if (re.test(out)) {
      hit = true;
      out = out.replace(re, (m) => matchCase(m, en));
    }
  }
  return hit ? out : null;
};

// Translate a single UI string from Spanish to English.
export const translate = (raw) => {
  if (!raw) return null;
  const lead = raw.match(/^\s*/)[0];
  const trail = raw.match(/\s*$/)[0];
  const s = raw.trim();
  if (!s || /^[\d\s.,:•|/$L+%()-]*$/.test(s)) return null;

  let out = DICT[s];
  if (out === undefined) {
    // "Texto:" / "Texto" variants
    const noColon = s.replace(/:$/, '');
    if (s.endsWith(':') && DICT[noColon] !== undefined) out = `${DICT[noColon]}:`;
  }
  if (out === undefined) {
    const m = s.match(/^Hace\s+(\d+)\s+(día|días|semana|semanas|hora|horas|min|minutos|mes|meses)$/i);
    if (m) {
      const unit = { 'día': 'day', 'días': 'days', semana: 'week', semanas: 'weeks', hora: 'hour', horas: 'hours', min: 'min', minutos: 'minutes', mes: 'month', meses: 'months' }[m[2].toLowerCase()];
      out = `${m[1]} ${unit} ago`;
    }
  }
  if (out === undefined) out = wordTranslate(s);
  if (out === undefined || out === null || out === s) return null;
  return lead + out + trail;
};
